import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
import { withApollo } from '@apollo/client/react/hoc';
import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Col, Container, Row } from 'reactstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { format } from 'date-fns';
import Icon from '../../../components/Icon';
// @ts-expect-error TS2307: Cannot find module
import GenerateRepositoryToken from '../../../graphql/mutations/generateRepositoryToken.graphql';
// @ts-expect-error TS2307: Cannot find module
import RemoveRepositoryToken from '../../../graphql/mutations/removeRepositoryToken.graphql';
// @ts-expect-error TS2307: Cannot find module
import RevokeRepositoryToken from '../../../graphql/mutations/revokeRepositoryToken.graphql';
import RepositoryToken from '../../../model/entities/RepositoryToken';
class Tokens extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            mounted: false,
            tokens: [],
            generatingToken: false,
            removingTokens: [],
            revokingTokens: [],
            copiedTokenId: null,
        };
        this.handleGenerateToken = async () => {
            this.setState({ generatingToken: true });
            const { data: { generateRepositoryToken: { data } } } = await this.props.client.mutate({
                mutation: GenerateRepositoryToken,
                variables: {
                    request: {
                        id: this.props.repositoryId,
                    },
                },
            });
            this.setState((state) => ({
                generatingToken: false,
                tokens: [...state.tokens, new RepositoryToken({ ...data, new: true })],
            }), () => {
                this.props.onUpdateTokens?.([...this.state.tokens]);
            });
        };
        this.handleRemoveToken = async (token) => {
            this.setState((state) => ({
                removingTokens: [...state.removingTokens, token.id],
            }));
            const { data } = await this.props.client.mutate({
                mutation: RemoveRepositoryToken,
                variables: {
                    request: {
                        id: token.id,
                    },
                },
            });
            this.setState((state) => ({
                removingTokens: state.removingTokens.filter(t => t !== token.id),
                ...(data && ({ tokens: state.tokens.filter(t => t.id !== token.id) })),
            }), () => {
                this.props.onUpdateTokens?.([...this.state.tokens]);
            });
        };
        this.handleRevokeToken = async (token) => {
            this.setState((state) => ({
                revokingTokens: [...state.revokingTokens, token.id],
            }));
            const { data } = await this.props.client.mutate({
                mutation: RevokeRepositoryToken,
                variables: {
                    request: {
                        id: token.id,
                    },
                },
            });
            this.setState((state) => ({
                revokingTokens: state.revokingTokens.filter(t => t !== token.id),
                ...(data && ({
                    tokens: state.tokens.map(stateToken => {
                        if (stateToken.id === token.id) {
                            stateToken.setExpiration(Date.now());
                        }
                        return stateToken;
                    }),
                })),
            }));
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (!prevState.mounted) {
            return { mounted: true, tokens: nextProps.tokens ?? [] };
        }
        return null;
    }
    componentWillUnmount() {
        const updatedTokens = this.state.tokens.map(token => {
            token.setNew(false);
            token.setToken(token.new ? token.token : token.getToken());
            return token;
        });
        this.props.onUpdateTokens?.(updatedTokens);
    }
    render() {
        const { t } = this.props;
        const { copiedTokenId, generatingToken, removingTokens, revokingTokens, tokens } = this.state;
        const showCopyWarning = tokens.filter(token => token.new).length;
        return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "d-flex", children: [_jsx("h3", { className: "h4 flex-grow-1", children: t('settings.tokens') }), _jsx("div", { children: _jsxs(Button, { color: "primary", disabled: generatingToken, onClick: this.handleGenerateToken, size: "sm", children: [generatingToken && _jsx(Icon, { name: "spinner", className: "mr-2", fixedWidth: true, spin: true }), t('settings.generateToken')] }) })] }), _jsx("p", { children: t('settings.tokensDescription') }), _jsxs(Container, { className: "pl-0 pl-md-1 pr-0 pr-md-1", children: [_jsxs(Row, { className: "border-bottom pb-2", children: [_jsx(Col, { className: "col-12 col-md-5 font-weight-bold", children: t('settings.token') }), _jsx(Col, { className: "d-none d-md-block col-md-3 font-weight-bold text-nowrap", children: t('settings.tokenExpiration') }), _jsx(Col, { className: "d-none d-md-block col-md-4 font-weight-bold text-nowrap", children: t('settings.lastUsed') })] }), tokens.map((token, index) => (_jsxs(Row, { className: clsx('border-bottom pt-2 pb-2', index % 2 === 0 && 'bg-light'), children: [_jsxs(Col, { className: "col-12 col-md-5 align-self-center", children: [token.getToken(), token.new && (_jsx(CopyToClipboard
                                        // @ts-expect-error TS2769: No overload matches this call.
                                        , { 
                                            // @ts-expect-error TS2769: No overload matches this call.
                                            className: clsx('ml-2', copiedTokenId !== token.id ? 'cursor--pointer' : 'text-grey-light'), text: token.getToken(), title: t('copyToClipboard'), onCopy: () => this.setState(() => ({ copiedTokenId: token.id })), children: _jsx(Icon, { name: "copy-regular" }) }))] }), _jsxs(Col, { className: "col-12 col-md-3 align-self-center", children: [_jsxs("span", { className: "d-md-none", children: [t('settings.tokenExpiration'), ": "] }), token.expiration ? format(new Date(Number(token.expiration)), t('dateTimeLongFormat')) : '-'] }), _jsxs(Col, { className: "col-12 col-md-4 d-flex", title: `${t('settings.createdAt')}: ${format(new Date(Number(token.createdAt)), t('dateTimeLongFormat'))}`, children: [_jsxs("div", { className: "flex-grow-1 align-self-center", children: [_jsxs("span", { className: "d-md-none", children: [t('settings.lastUsed'), ": "] }), token.lastUsed ? format(new Date(Number(token.lastUsed)), t('dateTimeLongFormat')) : '-'] }), _jsx("div", { children: !token.expiration || new Date(token.expiration).getTime() > Date.now() ? (_jsxs(Button, { className: "text-nowrap text-white", color: "danger", disabled: revokingTokens.includes(token.id), onClick: () => this.handleRevokeToken(token), size: "sm", children: [revokingTokens.includes(token.id) &&
                                                        _jsx(Icon, { name: "spinner", className: "mr-2", fixedWidth: true, spin: true }), t('settings.revokeToken')] })) : (_jsxs(Button, { className: "text-nowrap text-white", color: "danger", disabled: removingTokens.includes(token.id), onClick: () => this.handleRemoveToken(token), size: "sm", children: [removingTokens.includes(token.id) &&
                                                        _jsx(Icon, { name: "spinner", className: "mr-2", fixedWidth: true, spin: true }), t('settings.removeToken')] })) })] })] }, token.id))), tokens.length === 0 && (_jsx(Row, { children: _jsx(Col, { className: "text-md-center pt-2 pb-2", children: t('settings.noTokens') }) }))] }), showCopyWarning > 0 && (_jsx("p", { className: "alert alert-warning mt-3", children: showCopyWarning === 1 ? t('settings.copyTokenWarning') : t('settings.copyTokensWarning') }))] }));
    }
}
// @ts-expect-error TS2345: Argument of type 'typeof Tokens' is not assignable to parameter of type 'ComponentType<any>'.
export default withApollo(withTranslation()(Tokens));
